export default __webpack_public_path__ + "static/media/highlight-3-new.37db03a3.png";